import React from 'react';
import styles from '../Operations.module.css';

interface BTYGComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const BTYG: BTYGComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Rolling 12 months B2B sales as compared to the immediately preceding 12 months. Determined by totaling sales of segmented business customers (instore and online) and National Accounts customers.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        This metric is dependent upon stores completing and maintaining their business customer segmentation.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        Higher ground goals: achieve one of the two B2B metrics, B2B sales as a percent of total sales or B2B sales growth.
        <br /><br />
        <strong>Platinum:</strong> Achieve growth of at least 7% or 10% of your total sales going to a B2B customer during a rolling 12 month period (minimum 5% B2B to Total)
        <br /><br />
        <strong>Pinnacle:</strong> Achieve growth of at least 10% or 15% of your total sales going to a B2B customer during a rolling 12 month period (minimum 5% B2B to Total)
        <br /><br />
        <strong>Requirements:</strong> Must achieve 5% B2B to Total to start the climb to Higher Ground.
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
        Drill down provides the ability to see the YOY results by customer segment including sales, average transaction, and transaction count.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Consult with your B2B Field Sales Manager and review/implement the Business to Business training and B2B Playbook to build the culture and practices to grow the relationships and sales with your local business customers.
        <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Appoint a B2B Champion and assign training.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Ensure the B2B Champion and Leadership are signed up to receive monthly B2B sales reports.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Implement a process to set up new B2B customers in store
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; • Contact customers to learn more about their supply needs.
      </div>
    </div>
  );
};

BTYG.title = 'Business to Business - Year over Year Growth';
BTYG.actionTitle = 'Review B2B Sales by Customer Segment';
BTYG.actionHyperlink = 'dynamicURL:WFC:current';
export default BTYG;

